<template>
  <div class="bg-white w-full">
    <div v-if="discountedPrice" class="w-full flex flex-row items-end">
      <div class="flex flex-col">
        <div class="font-normal text-[#222222] opacity-50 text-[13px] leading-[100%]">WAS:</div>
        <div class="font-medium text-[#23A94B] text-[13px] leading-[100%] mb-[5px] mt-[18px]">TODAY:</div>
      </div>
      <div class="flex-col">
        <div
          class="font-normal text-[#222222] opacity-50 text-[24px] leading-[100%] ml-[8px] line-through decoration-2"
        >
          ${{ withFixedDecimals(originalPrice) }}
        </div>
        <div class="inline-flex items-end font-medium text-[#23A94B] mt-[8px]">
          <div class="text-[24px] leading-[100%] ml-[8px]">${{ withFixedDecimals(discountedPrice) }}</div>
          <div class="text-[13px] leading-[100%] mb-[4px] ml-[8px]">
            (${{ withFixedDecimals(breakdown.price) }}/{{ breakdown.unit }})
          </div>
        </div>
      </div>
    </div>
    <div v-else class="w-full flex flex-row items-end">
      <div class="font-bold text-[32px] leading-[100%] text-[#003F82]">${{ withFixedDecimals(originalPrice) }}</div>
      <div class="font-bold text-[13px] leading-[100%] text-[#003F82] ml-[8px] mb-[4px]">
        (${{ withFixedDecimals(breakdown.price) }}/{{ breakdown.unit }})
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  originalPrice: number;
  discountedPrice?: number;
  breakdown: {
    price: number;
    unit: string;
  };
}>();

function withFixedDecimals(n: number): string {
  return n.toFixed(2);
}
</script>

<style scoped>
@tailwind utilities;
</style>
